/*
 * AC Batch14 header/navigation accessibility layer.
 * Additive only: it never opens/closes menus itself. It relays keyboard input to the
 * existing Avone click handlers (theme.Header) and mirrors their state into ARIA.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  root.ACHeaderNav = api;
  if (root.document) api.boot(root.document);
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var EXPANDED = 'ad-minus-l';
  var COLLAPSED = 'ad-plus-l';
  var ICON_SELECTOR = '#MobileNav .ad.' + COLLAPSED + ', #MobileNav .ad.' + EXPANDED;

  function create(doc) {
    var listeners = [];
    var observers = [];
    var lastToggle = null;
    var active = false;

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      listeners.push([target, type, fn, opts]);
    }
    function header() { return doc.querySelector('[data-ac-header]'); }
    function label(key, fallback) {
      var h = header();
      return (h && h.getAttribute('data-ac-nav-' + key)) || fallback;
    }
    function wrapper() { return doc.querySelector('.mobile-nav-wrapper'); }
    function isOpen() { var w = wrapper(); return !!(w && w.classList.contains('active')); }
    function toggles() { return Array.prototype.slice.call(doc.querySelectorAll('.js-mobile-nav-toggle')); }
    function cartOpen() { var c = doc.getElementById('cart-drawer'); return !!(c && c.classList.contains('active')); }

    function syncMenu() {
      var open = isOpen();
      toggles().forEach(function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.setAttribute('aria-label', open ? label('close', 'Close menu') : label('open', 'Open menu'));
      });
    }

    function linkText(icon) {
      var a = icon.parentNode;
      var txt = a && a.textContent ? a.textContent.replace(/\s+/g, ' ').trim() : '';
      return label('submenu', 'Show or hide submenu') + (txt ? ': ' + txt : '');
    }
    function syncIcon(icon) {
      icon.setAttribute('aria-expanded', icon.classList.contains(EXPANDED) ? 'true' : 'false');
    }
    function enhanceIcons() {
      Array.prototype.forEach.call(doc.querySelectorAll(ICON_SELECTOR), function (icon) {
        if (icon.getAttribute('data-ac-nav-toggle') === '1') return;
        icon.setAttribute('data-ac-nav-toggle', '1');
        icon.setAttribute('role', 'button');
        icon.setAttribute('tabindex', '0');
        icon.removeAttribute('aria-hidden');
        icon.setAttribute('aria-label', linkText(icon));
        syncIcon(icon);
        if (typeof MutationObserver === 'function') {
          var mo = new MutationObserver(function () { syncIcon(icon); });
          mo.observe(icon, { attributes: true, attributeFilter: ['class'] });
          observers.push(mo);
        }
      });
      var close = doc.querySelector('.mobile-nav-wrapper .closemobileMenu');
      if (close && !close.hasAttribute('data-ac-nav-close')) {
        close.setAttribute('data-ac-nav-close', '1');
        close.setAttribute('role', 'button');
        close.setAttribute('tabindex', '0');
      }
    }

    function firstMenuLink() { return doc.querySelector('#MobileNav a[href]'); }
    function focusables() {
      var w = wrapper();
      if (!w) return [];
      return Array.prototype.slice.call(w.querySelectorAll('a[href], [data-ac-nav-toggle], [data-ac-nav-close]'))
        .filter(function (el) { return el === doc.activeElement || (!el.closest('[hidden]') && el.offsetParent !== null); });
    }

    // Closed drawer: inert + aria-hidden so off-screen links leave the Tab order.
    var savedWrapperAttrs = null;
    function drawerVisible() {
      var w = wrapper(), win = doc.defaultView;
      if (!w || !w.classList.contains('active') || !win || !win.getComputedStyle) return false;
      var cs = win.getComputedStyle(w);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      var r = w.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.right > 0 && r.left < (win.innerWidth || 0);
    }
    function syncHidden() {
      var w = wrapper();
      if (!w) return;
      if (!savedWrapperAttrs) savedWrapperAttrs = { el: w, inert: w.getAttribute('inert'), hidden: w.getAttribute('aria-hidden') };
      if (isOpen()) { w.removeAttribute('inert'); w.removeAttribute('aria-hidden'); }
      else { w.setAttribute('inert', ''); w.setAttribute('aria-hidden', 'true'); }
    }
    function closeViaNative() {
      var close = doc.querySelector('.mobile-nav-wrapper .closemobileMenu') || toggles()[0];
      if (close) activate(close);
    }
    function onResize() {
      // Viewport moved to desktop (drawer hidden by theme CSS) while open: close through the native control.
      if (isOpen() && !drawerVisible()) closeViaNative();
    }

    // Real drawer slides in (left/transform transition): focus the first link once it is on screen.
    var pendingFocus = null; // { timers: [] }
    function cancelPendingFocus() {
      if (!pendingFocus) return;
      var win = doc.defaultView;
      pendingFocus.timers.forEach(function (id) { if (win) win.clearTimeout(id); });
      pendingFocus = null;
    }
    function tryPendingFocus(final) {
      if (!pendingFocus) return;
      var w = wrapper();
      if (!isOpen() || !w || w.contains(doc.activeElement)) { cancelPendingFocus(); return; }
      if (drawerVisible()) {
        cancelPendingFocus();
        var link = firstMenuLink();
        if (link && typeof link.focus === 'function') link.focus();
      } else if (final) cancelPendingFocus();
    }
    function startPendingFocus() {
      cancelPendingFocus();
      var win = doc.defaultView;
      pendingFocus = { timers: [] };
      if (!win) return;
      // Bounded fallback after the 0.3s legacy animation in case transitionend never fires.
      pendingFocus.timers.push(win.setTimeout(function () { tryPendingFocus(false); }, 400));
      pendingFocus.timers.push(win.setTimeout(function () { tryPendingFocus(true); }, 900));
    }
    function onTransitionEnd(e) {
      var w = wrapper();
      if (!pendingFocus || !w || e.target !== w) return;
      if (e.propertyName !== 'left' && e.propertyName !== 'transform') return;
      tryPendingFocus(false);
    }

    var wasOpen = false;
    function onMenuState() {
      var open = isOpen();
      syncMenu();
      syncHidden(); // release inert before any focus move
      if (open && !wasOpen) {
        var link = firstMenuLink();
        if (drawerVisible()) { if (link && typeof link.focus === 'function') link.focus(); }
        else startPendingFocus();
      } else if (!open && wasOpen) {
        cancelPendingFocus();
        var w = wrapper();
        if (w && w.contains(doc.activeElement)) {
          var back = lastToggle && doc.contains(lastToggle) ? lastToggle : toggles()[0];
          if (back) back.focus();
        }
      }
      wasOpen = open;
    }

    function activate(el) {
      if (typeof el.click === 'function') el.click();
      else el.dispatchEvent(new doc.defaultView.MouseEvent('click', { bubbles: true, cancelable: true }));
    }

    function onKeydown(e) {
      var t = e.target;
      var key = e.key;
      var isActivate = key === 'Enter' || key === ' ' || key === 'Spacebar';
      if (isActivate && t && t.getAttribute && (t.getAttribute('data-ac-nav-toggle') === '1' || t.getAttribute('data-ac-nav-close') === '1')) {
        e.preventDefault();
        e.stopPropagation();
        activate(t);
        return;
      }
      if (key === ' ' && t && t.classList && t.classList.contains('js-mobile-nav-toggle')) {
        e.preventDefault();
        activate(t);
        return;
      }
      if (key === 'Escape' || key === 'Esc') {
        if (cartOpen()) return; // Batch6 mini-cart owns Escape while it is open.
        if (isOpen()) {
          e.preventDefault();
          closeViaNative();
          return;
        }
        var item = t && t.closest ? t.closest('#siteNav .lvl1.parent') : null;
        if (item) {
          e.preventDefault();
          closeItem(item);
          item.classList.add('ac-nav-dismissed');
          var top = topLink(item);
          if (top) top.focus();
          scheduleSync();
        }
        return;
      }
      if (isActivate && t && t.tagName === 'A' && t.parentNode && t.parentNode.matches &&
          t.parentNode.matches('#siteNav > .lvl1.parent') && panelOf(t.parentNode)) {
        // Desktop launcher: placeholder (#) never jumps; Space never scrolls. Real links keep Enter.
        if (key === 'Enter' && !isPlaceholder(t)) return;
        e.preventDefault();
        var li = t.parentNode;
        li.classList.remove('ac-nav-dismissed');
        li.classList.add('ac-nav-open');
        scheduleSync();
        return;
      }
      if (key === 'Tab' && isOpen() && drawerVisible()) {
        var list = focusables();
        if (!list.length) return;
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    // ---- Desktop top-level ARIA mirror + placeholder activation (no role=menu) ----
    var syncTimer = null;
    var enhancedTops = [];
    function topItems() { return Array.prototype.slice.call(doc.querySelectorAll('#siteNav > .lvl1.parent')); }
    function panelOf(item) {
      for (var c = item.firstElementChild; c; c = c.nextElementSibling) {
        if ((c.tagName === 'DIV' && c.classList.contains('megamenu')) || (c.tagName === 'UL' && c.classList.contains('dropdown'))) return c;
      }
      return null;
    }
    function topLink(item) {
      for (var c = item.firstElementChild; c; c = c.nextElementSibling) if (c.tagName === 'A') return c;
      return null;
    }
    function isPlaceholder(a) {
      var h = a.getAttribute('href');
      return h === null || h === '' || h === '#';
    }
    function panelVisible(p) {
      var win = doc.defaultView;
      if (!p || !win || !win.getComputedStyle) return false;
      var cs = win.getComputedStyle(p);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && p.getClientRects().length > 0;
    }
    function syncDesktop() {
      syncTimer = null;
      topItems().forEach(function (item) {
        var a = topLink(item), p = panelOf(item);
        if (a && p) a.setAttribute('aria-expanded', panelVisible(p) ? 'true' : 'false');
      });
    }
    // Native panels reveal with a CSS transition: re-check after it settles (bounded).
    var settleTimers = [];
    function clearSettle() {
      var win = doc.defaultView;
      settleTimers.forEach(function (id) { if (win) win.clearTimeout(id); });
      settleTimers = [];
    }
    function scheduleSync() {
      var win = doc.defaultView;
      if (!win) return;
      if (syncTimer === null) syncTimer = win.setTimeout(syncDesktop, 0);
      clearSettle();
      settleTimers.push(win.setTimeout(syncDesktop, 350));
      settleTimers.push(win.setTimeout(function () { settleTimers = []; syncDesktop(); }, 800));
    }
    function onPanelTransitionEnd(e) {
      var t = e.target;
      if (!t || !t.parentNode || !t.parentNode.matches || !t.parentNode.matches('#siteNav > .lvl1.parent')) return;
      if (panelOf(t.parentNode) !== t) return;
      syncDesktop();
    }
    function enhanceDesktop() {
      topItems().forEach(function (item, i) {
        var a = topLink(item), p = panelOf(item);
        if (!a || !p) return;
        var added = !p.id;
        if (added) p.id = 'ac-nav-panel-' + (i + 1);
        a.setAttribute('aria-controls', p.id);
        a.setAttribute('aria-expanded', 'false');
        enhancedTops.push([a, p, added]);
      });
      syncDesktop();
    }
    function closeItem(item) {
      item.classList.remove('ac-nav-open');
    }

    function onFocusIn(e) {
      scheduleSync();
      var t = e.target;
      if (!t || !t.closest) return;
      var sub = t.closest('#siteNav .hasSub');
      if (sub) {
        var target = sub.getAttribute('data-link');
        var scope = sub.closest('.megamenu') || doc;
        var panel = target ? doc.getElementById(target.replace(/^#/, '')) : null;
        if (panel) {
          Array.prototype.forEach.call(scope.querySelectorAll('.admmsub'), function (p) {
            if (p !== panel) p.classList.remove('active');
          });
          panel.classList.add('active');
        }
      }
    }
    function onFocusOut(e) {
      var item = e.target && e.target.closest ? e.target.closest('#siteNav .lvl1.parent') : null;
      if (item && !item.contains(e.relatedTarget)) { item.classList.remove('ac-nav-dismissed'); closeItem(item); }
      scheduleSync();
    }
    function onPointerLeave(e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('ac-nav-dismissed')) t.classList.remove('ac-nav-dismissed');
    }
    function onHover() { scheduleSync(); }
    function onClickCapture(e) {
      var t = e.target && e.target.closest ? e.target.closest('.js-mobile-nav-toggle') : null;
      if (t) lastToggle = t;
    }

    function init() {
      if (active) return;
      active = true;
      enhanceIcons();
      toggles().forEach(function (t) {
        t.setAttribute('role', 'button');
        if (doc.getElementById('MobileNav')) t.setAttribute('aria-controls', 'MobileNav');
      });
      wasOpen = isOpen();
      syncMenu();
      syncHidden();
      var w = wrapper();
      if (w && typeof MutationObserver === 'function') {
        var mo = new MutationObserver(onMenuState);
        mo.observe(w, { attributes: true, attributeFilter: ['class'] });
        observers.push(mo);
      }
      on(doc, 'keydown', onKeydown, true);
      on(doc, 'focusin', onFocusIn, false);
      on(doc, 'focusout', onFocusOut, false);
      on(doc, 'mouseleave', onPointerLeave, true);
      on(doc, 'click', onClickCapture, true);
      on(doc, 'mouseover', onHover, true);
      on(doc, 'mouseout', onHover, true);
      if (doc.defaultView) on(doc.defaultView, 'resize', onResize, false);
      if (w) on(w, 'transitionend', onTransitionEnd, false);
      on(doc, 'transitionend', onPanelTransitionEnd, true);
      enhanceDesktop();
      onResize();
    }

    function destroy() {
      cancelPendingFocus();
      listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      listeners = [];
      observers.forEach(function (o) { o.disconnect(); });
      observers = [];
      Array.prototype.forEach.call(doc.querySelectorAll('[data-ac-nav-toggle]'), function (el) { el.removeAttribute('data-ac-nav-toggle'); });
      Array.prototype.forEach.call(doc.querySelectorAll('[data-ac-nav-close]'), function (el) { el.removeAttribute('data-ac-nav-close'); });
      if (syncTimer !== null && doc.defaultView) doc.defaultView.clearTimeout(syncTimer);
      clearSettle();
      syncTimer = null;
      enhancedTops.forEach(function (r) {
        r[0].removeAttribute('aria-controls'); r[0].removeAttribute('aria-expanded');
        if (r[2]) r[1].removeAttribute('id');
        if (r[0].parentNode) r[0].parentNode.classList.remove('ac-nav-open', 'ac-nav-dismissed');
      });
      enhancedTops = [];
      if (savedWrapperAttrs) {
        var sw = savedWrapperAttrs.el;
        if (savedWrapperAttrs.inert === null) sw.removeAttribute('inert'); else sw.setAttribute('inert', savedWrapperAttrs.inert);
        if (savedWrapperAttrs.hidden === null) sw.removeAttribute('aria-hidden'); else sw.setAttribute('aria-hidden', savedWrapperAttrs.hidden);
        savedWrapperAttrs = null;
      }
      lastToggle = null;
      active = false;
    }

    return { init: init, destroy: destroy, isActive: function () { return active; }, listenerCount: function () { return listeners.length; } };
  }

  function boot(doc) {
    var win = doc.defaultView || {};
    if (win.__acHeaderNav) return win.__acHeaderNav;
    var instance = create(doc);
    var start = function () { if (doc.querySelector('[data-ac-header]')) instance.init(); };
    var relevant = function (e) {
      var id = e && e.detail && e.detail.sectionId;
      return !id || id === 'header' || id === 'navigation';
    };
    doc.addEventListener('shopify:section:unload', function (e) { if (relevant(e)) instance.destroy(); });
    doc.addEventListener('shopify:section:load', function (e) { if (relevant(e)) { instance.destroy(); start(); } });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
    else start();
    win.__acHeaderNav = instance;
    return instance;
  }

  return { create: create, boot: boot };
});
